/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type PermissionName = typeof PermissionName[keyof typeof PermissionName];


export const PermissionName = {
  ROLES_READ: 'ROLES_READ',
  ROLES_WRITE: 'ROLES_WRITE',
  PERMISSIONS_READ: 'PERMISSIONS_READ',
  ROLEPERMISSIONS_READ: 'ROLEPERMISSIONS_READ',
  ROLEPERMISSIONS_WRITE: 'ROLEPERMISSIONS_WRITE',
  QUEUES_READ: 'QUEUES_READ',
  QUEUES_WRITE: 'QUEUES_WRITE',
  USERS_READ: 'USERS_READ',
  USERS_WRITE: 'USERS_WRITE',
  SKILLS_READ: 'SKILLS_READ',
  SKILLS_WRITE: 'SKILLS_WRITE',
  RULES_READ: 'RULES_READ',
  RULES_WRITE: 'RULES_WRITE',
  PAUSEREASONS_READ: 'PAUSEREASONS_READ',
  PAUSEREASONS_WRITE: 'PAUSEREASONS_WRITE',
  CUSTOMPROPERTIES_READ: 'CUSTOMPROPERTIES_READ',
  CUSTOMPROPERTIES_WRITE: 'CUSTOMPROPERTIES_WRITE',
  CUSTOMPROPERTYRULES_READ: 'CUSTOMPROPERTYRULES_READ',
  CUSTOMPROPERTYRULES_WRITE: 'CUSTOMPROPERTYRULES_WRITE',
  USERQUEUES_READ: 'USERQUEUES_READ',
  USERQUEUES_WRITE: 'USERQUEUES_WRITE',
  USERSKILLS_READ: 'USERSKILLS_READ',
  USERSKILLS_WRITE: 'USERSKILLS_WRITE',
  SETTINGS_READ: 'SETTINGS_READ',
  SETTINGS_WRITE: 'SETTINGS_WRITE',
  USERSETTINGS_READ: 'USERSETTINGS_READ',
  USERSETTINGS_WRITE: 'USERSETTINGS_WRITE',
  TEAMS_READ: 'TEAMS_READ',
  TEAMS_WRITE: 'TEAMS_WRITE',
  TEAMUSERS_READ: 'TEAMUSERS_READ',
  TEAMUSERS_WRITE: 'TEAMUSERS_WRITE',
  TEMPLATES_READ: 'TEMPLATES_READ',
  TEMPLATES_WRITE: 'TEMPLATES_WRITE',
  USERROLES_READ: 'USERROLES_READ',
  USERROLES_WRITE: 'USERROLES_WRITE',
  USERTEMPLATES_WRITE: 'USERTEMPLATES_WRITE',
  CUSTOMPAGES_READ: 'CUSTOMPAGES_READ',
  CUSTOMPAGES_WRITE: 'CUSTOMPAGES_WRITE',
  USERCUSTOMPAGES_READ: 'USERCUSTOMPAGES_READ',
  USERCUSTOMPAGES_WRITE: 'USERCUSTOMPAGES_WRITE',
  PHONEBOOK_READ: 'PHONEBOOK_READ',
  TEAMSETTINGS_READ: 'TEAMSETTINGS_READ',
  TEAMSETTINGS_WRITE: 'TEAMSETTINGS_WRITE',
  ROLES_MODIFY: 'ROLES_MODIFY',
  PERMISSIONS_MODIFY: 'PERMISSIONS_MODIFY',
  ROLEPERMISSIONS_MODIFY: 'ROLEPERMISSIONS_MODIFY',
  QUEUES_MODIFY: 'QUEUES_MODIFY',
  USERS_MODIFY: 'USERS_MODIFY',
  SKILLS_MODIFY: 'SKILLS_MODIFY',
  RULES_MODIFY: 'RULES_MODIFY',
  PAUSEREASONS_MODIFY: 'PAUSEREASONS_MODIFY',
  CUSTOMPROPERTIES_MODIFY: 'CUSTOMPROPERTIES_MODIFY',
  CUSTOMPROPERTYRULES_MODIFY: 'CUSTOMPROPERTYRULES_MODIFY',
  USERQUEUES_MODIFY: 'USERQUEUES_MODIFY',
  USERSKILLS_MODIFY: 'USERSKILLS_MODIFY',
  SETTINGS_MODIFY: 'SETTINGS_MODIFY',
  USERSETTINGS_MODIFY: 'USERSETTINGS_MODIFY',
  TEAMS_MODIFY: 'TEAMS_MODIFY',
  TEAMUSERS_MODIFY: 'TEAMUSERS_MODIFY',
  TEMPLATES_MODIFY: 'TEMPLATES_MODIFY',
  USERROLES_MODIFY: 'USERROLES_MODIFY',
  USERTEMPLATES_MODIFY: 'USERTEMPLATES_MODIFY',
  CUSTOMPAGES_MODIFY: 'CUSTOMPAGES_MODIFY',
  USERCUSTOMPAGES_MODIFY: 'USERCUSTOMPAGES_MODIFY',
  PHONEBOOK_MODIFY: 'PHONEBOOK_MODIFY',
  TEAMSETTINGS_MODIFY: 'TEAMSETTINGS_MODIFY',
  TEAMQUEUES_MODIFY: 'TEAMQUEUES_MODIFY',
  TEAMQUEUES_WRITE: 'TEAMQUEUES_WRITE',
  TEAMQUEUES_READ: 'TEAMQUEUES_READ',
  TEAMSKILLS_READ: 'TEAMSKILLS_READ',
  TEAMSKILLS_WRITE: 'TEAMSKILLS_WRITE',
  TEAMSKILLS_MODIFY: 'TEAMSKILLS_MODIFY',
  TEAMCUSTOMPAGES_MODIFY: 'TEAMCUSTOMPAGES_MODIFY',
  TEAMCUSTOMPAGES_READ: 'TEAMCUSTOMPAGES_READ',
  TEAMCUSTOMPAGES_WRITE: 'TEAMCUSTOMPAGES_WRITE',
  TEAMROLES_MODIFY: 'TEAMROLES_MODIFY',
  TEAMROLES_READ: 'TEAMROLES_READ',
  TEAMROLES_WRITE: 'TEAMROLES_WRITE',
  ORGUNITS_MODIFY: 'ORGUNITS_MODIFY',
  ORGUNITS_READ: 'ORGUNITS_READ',
  ORGUNITS_WRITE: 'ORGUNITS_WRITE',
  ABSENCES_MODIFY: 'ABSENCES_MODIFY',
  ABSENCES_READ: 'ABSENCES_READ',
  ABSENCES_WRITE: 'ABSENCES_WRITE',
  CLIENTCREDENTIALS_READ: 'CLIENTCREDENTIALS_READ',
  CLIENTCREDENTIALS_WRITE: 'CLIENTCREDENTIALS_WRITE',
  CLIENTCREDENTIALS_MODIFY: 'CLIENTCREDENTIALS_MODIFY',
  CONTACTCODES_READ: 'CONTACTCODES_READ',
  CONTACTCODES_WRITE: 'CONTACTCODES_WRITE',
  CONTACTCODES_MODIFY: 'CONTACTCODES_MODIFY',
  CONTACTCODETREE_READ: 'CONTACTCODETREE_READ',
  CONTACTCODETREE_WRITE: 'CONTACTCODETREE_WRITE',
  CONTACTCODETREE_MODIFY: 'CONTACTCODETREE_MODIFY',
  CONTACTCODETREEITEM_WRITE: 'CONTACTCODETREEITEM_WRITE',
  CONTACTCODETREEITEM_MODIFY: 'CONTACTCODETREEITEM_MODIFY',
  CONTACTCODETREEITEM_READ: 'CONTACTCODETREEITEM_READ',
  CONTACTCODETREEQUEUE_WRITE: 'CONTACTCODETREEQUEUE_WRITE',
  CONTACTCODETREEQUEUE_MODIFY: 'CONTACTCODETREEQUEUE_MODIFY',
  CONTACTCODETREEQUEUE_READ: 'CONTACTCODETREEQUEUE_READ',
  SKILLGROUPS_READ: 'SKILLGROUPS_READ',
  SKILLGROUPS_WRITE: 'SKILLGROUPS_WRITE',
  SKILLGROUPS_MODIFY: 'SKILLGROUPS_MODIFY',
  TEAMSKILLGROUPS_READ: 'TEAMSKILLGROUPS_READ',
  TEAMSKILLGROUPS_WRITE: 'TEAMSKILLGROUPS_WRITE',
  TEAMSKILLGROUPS_MODIFY: 'TEAMSKILLGROUPS_MODIFY',
  USERSKILLGROUPS_READ: 'USERSKILLGROUPS_READ',
  USERSKILLGROUPS_WRITE: 'USERSKILLGROUPS_WRITE',
  USERSKILLGROUPS_MODIFY: 'USERSKILLGROUPS_MODIFY',
  TEAMPAUSEREASONS_READ: 'TEAMPAUSEREASONS_READ',
  TEAMPAUSEREASONS_WRITE: 'TEAMPAUSEREASONS_WRITE',
  USERPAUSEREASONS_READ: 'USERPAUSEREASONS_READ',
  USERPAUSEREASONS_WRITE: 'USERPAUSEREASONS_WRITE',
  SKILLGROUPSKILLS_READ: 'SKILLGROUPSKILLS_READ',
  SKILLGROUPSKILLS_WRITE: 'SKILLGROUPSKILLS_WRITE',
  SKILLGROUPSKILLS_MODIFY: 'SKILLGROUPSKILLS_MODIFY',
  TEMPLATESCUSTOMPAGES_READ: 'TEMPLATESCUSTOMPAGES_READ',
  TEMPLATESCUSTOMPAGES_WRITE: 'TEMPLATESCUSTOMPAGES_WRITE',
  TEMPLATESCUSTOMPAGES_MODIFY: 'TEMPLATESCUSTOMPAGES_MODIFY',
  TEMPLATESQUEUES_READ: 'TEMPLATESQUEUES_READ',
  TEMPLATESQUEUES_WRITE: 'TEMPLATESQUEUES_WRITE',
  TEMPLATESQUEUES_MODIFY: 'TEMPLATESQUEUES_MODIFY',
  TEMPLATESROLES_READ: 'TEMPLATESROLES_READ',
  TEMPLATESROLES_WRITE: 'TEMPLATESROLES_WRITE',
  TEMPLATESROLES_MODIFY: 'TEMPLATESROLES_MODIFY',
  TEMPLATESSKILLS_READ: 'TEMPLATESSKILLS_READ',
  TEMPLATESSKILLS_WRITE: 'TEMPLATESSKILLS_WRITE',
  TEMPLATESSKILLS_MODIFY: 'TEMPLATESSKILLS_MODIFY',
  TEMPLATESTEAMS_READ: 'TEMPLATESTEAMS_READ',
  TEMPLATESTEAMS_WRITE: 'TEMPLATESTEAMS_WRITE',
  TEMPLATESTEAMS_MODIFY: 'TEMPLATESTEAMS_MODIFY',
  TEMPLATESETTINGS_READ: 'TEMPLATESETTINGS_READ',
  TEMPLATESETTINGS_WRITE: 'TEMPLATESETTINGS_WRITE',
  TEMPLATESETTINGS_MODIFY: 'TEMPLATESETTINGS_MODIFY',
} as const;
